<fm-balloon-header color="black" [title]="balloon?.description" [subtitle]="balloon?.statusDescription"></fm-balloon-header>
<fm-balloon-section>
  <span>{{ balloon?.statusDescription }}: {{ balloon?.timestamp }}</span>
  <span [innerHTML]="balloon?.address"></span>
</fm-balloon-section>
<fm-balloon-section>
  <div class="garmin-balloon-section__row">
    <span> <span class="garmin-balloon__label" i18n="@@S_VEHICLE">Vehicle</span>: </span>
    <span>{{ balloon?.vehicleName }}</span>
  </div>
  <div class="garmin-balloon-section__row">
    <span> <span class="garmin-balloon__label" i18n="@@S_DRIVER">Driver</span>: </span>
    <span>{{ balloon?.driverName }}</span>
  </div>
</fm-balloon-section>
<fm-balloon-actions>
  <button
    mat-button
    class="vzc-small"
    id="btn-balloon-zoom-to"
    a7s-id="live-map-garmin-balloon-zoom-to"
    i18n="@@S_ZOOM_TO"
    (click)="onZoomTo()"
  >
    Zoom To
  </button>
  <button
    mat-button
    class="vzc-small"
    id="btn-balloon-street-view"
    a7s-id="live-map-garmin-balloon-street-view"
    i18n="@@S_STREETVIEW"
    [disabled]="!isStreetViewAvailable"
    (click)="onStreetView()"
  >
    Street View
  </button>
</fm-balloon-actions>
